// import { ErrorHandler } from "@/core/ErrorApi/ErrorHandler.js";
import Locale from "@/helper/locale/locale.js";
import { ErrorHandler } from "../core/ErrorApi/ErrorHandler";

export default {
    data: function () {
        return {
            errorHandler: new ErrorHandler(),
        };
    },
    methods: {
        errorApi: function(err, handler) {
            if (handler == null) {
                handler = new ErrorHandler();
            }

            if (this.alertModal) {
                handler.setAlertModal(this.alertModal);
            }

            if (this.noInternetModal) {
                handler.setNoInternetModal(this.noInternetModal);
            }

            if (err.response && err.response.data && err.response.data.error) {
                var error = err.response.data.error;
                handler.errorCase(error);
            } else {
                if (handler.noInternetModal != null) {
                    var lblDefault = Locale.getLbl().default;
                    handler.noInternetModal
                        .clearModal()
                        .setMsg(lblDefault.no_internet)
                        .show();
                }

                handler.errorCode(err);
            }
        }
    },
}
